import React from 'react'

const AboutIconOne = () => {
    return (
        <img src="https://img.icons8.com/ios-filled/50/000000/police-badge.png" alt="Law Enforcement Certified" style={{ width: '50px', height: '50px' }} />
    )
}

export default AboutIconOne